import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import { useInsights } from '~/stores/use-insights/useInsights';
import { METHOD_SUB_CLS_GROUPING } from '~/widgets/asset-overview-widget/method_sub_cls_grouping';

import { useAssetsTableStore } from '../useAssetsTableStore';
import { InsightsIcon } from './insights-icon/InsightsIcon';
import * as S from './InsightsCell.styles';

export type InsightsCellProps = {
  entityTag: string;
  setSelectedInsight: (insightId: string) => void;
  selectedInsight: string | undefined;
  setInsightsDrawerOpen: (open: boolean) => void;
  insightsDrawerOpen: boolean;
  isDisabled?: boolean;
};

export const InsightsCell = ({
  entityTag,
  setSelectedInsight,
  selectedInsight,
  setInsightsDrawerOpen,
  insightsDrawerOpen,
  isDisabled = false,
}: InsightsCellProps) => {
  const { getInsightsForEntity, loading } = useInsights();

  const insightsFilterState = useAssetsTableStore(
    state => state.insightsFilterState
  );

  const allInsights = getInsightsForEntity(entityTag);

  const getInsights = () => {
    if (Object.values(insightsFilterState).every(Boolean)) {
      return allInsights;
    }

    return allInsights.filter(insight => {
      const analysisType = METHOD_SUB_CLS_GROUPING[insight.metadata.topic];
      return analysisType ? insightsFilterState[analysisType] : false;
    });
  };

  if (loading) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '88px',
              height: '20px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  return (
    <S.InsightsContainer>
      {getInsights().map(i => (
        <InsightsIcon
          key={i.id}
          insight={i}
          setSelectedInsight={setSelectedInsight}
          selectedInsight={selectedInsight}
          setInsightsDrawerOpen={setInsightsDrawerOpen}
          insightsDrawerOpen={insightsDrawerOpen}
          isDisabled={isDisabled}
        />
      ))}
    </S.InsightsContainer>
  );
};
